/**
 * External dependencies
 */
import React, { useState } from 'react';
import { TowerProvider, Box } from '@towersystems/towersystems-design-system';

/**
 * Internal dependencies
 */
import Preloader from 'components/preloader';
import Button from 'components/button';
import ButtonGroup from 'components/button-group';
import Modal from 'components/modal';

const ConfirmRemovePaymentMethodDialog = ({ onClose, onSubmit, ...rest }) => {
    const [submitting, setSubmitting] = useState(false);
    return (
        <TowerProvider>
            <Modal className='remove-payment-method__dialog' close={!submitting && onClose} isVisible={true} header={false}>
                <Box
                    padding='xxlarge'
                    style={{ height: '100%' }}
                    display='flex'
                    flexDirection='column'
                    justifyContent='spaceBetween'
                >
                    {submitting && <Preloader />}
                    <div className='confirm-alert__title'>Remove payment method</div>
                    <div>
                        <p>
                            This payment method will be permanently removed from your account. This cannot be undone.
                        </p>
                    </div>
                    <ButtonGroup alignItems='center' justifyContent='center'>
                        <Button disabled={submitting} onClick={onClose}>Cancel</Button>
                        <Button
                            disabled={submitting}
                            primary
                            onClick={() => {
                                setSubmitting(true);
                                return onSubmit()
                                    .then(() => onClose())
                                    .catch((error) => console.log(error))
                                    .finally(() => {
                                        setSubmitting(false);
                                    });
                            }}
                        >
                            Remove
                        </Button>
                    </ButtonGroup>
                </Box>
            </Modal>
        </TowerProvider>
    );
};

export default ConfirmRemovePaymentMethodDialog;
